import * as React from 'react';
const classnames = require('classnames');
import { Button } from 'semantic-ui-react';
const FontAwesome = require('react-fontawesome');
// import _ from './utils'

const defaultButton = (props: any) => (
    <Button type="button" {...props} className="-btn">
        {props.children}
    </Button>
);

interface Props {
    page ?: any;
    pages ?: any;
   // showPageSizeOptions ?: any;
   // pageSizeOptions ?: any;
    pageSize ?: any;
    showPageJump ?: any;
    canPrevious ?: any;
    canNext ?: any;
  //  onPageSizeChange ?: any;
    className ?: any;
    PreviousComponent ?: any;
    NextComponent ?: any;
    style ?: any;
    ofText?: any;
    pageText?: any;
    rowsText?: any;
    previousText?: any;
    nextText?: any;
    onPageChange?: any;
}

interface State {
    page?: any;

}
export default class CustomPagination extends React.Component<Props, State> {
    private rowCount: number;
    private rowMin: number;
    private rowMax: number;

    constructor (props: any) {
        super(props);

        this.getSafePage = this.getSafePage.bind(this);
        this.changePage = this.changePage.bind(this);
        this.applyPage = this.applyPage.bind(this);

        this.updateCurrentRows(props);

        this.state = {
            page: props.page || ''
        };
    }

    componentWillReceiveProps (nextProps: any) {
        this.setState({ page: nextProps.page });
        this.updateCurrentRows(nextProps);
    }

    updateCurrentRows(props: any) {
        if (   typeof props.sortedData  !== 'undefined'  // use props.data for unfiltered (all) rows
            && typeof props.page !== 'undefined'
            && typeof props.pageSize !== 'undefined'
        ) {
            this.rowCount = props.sortedData.length; // use props.data.length for unfiltered (all) rows
            this.rowMin = props.page * props.pageSize + 1;
            this.rowMax = Math.min((props.page + 1) * props.pageSize, this.rowCount);
        }
    }

    getSafePage (page: any) {
        if (isNaN(page)) {
            page = this.props.page;
        }
        return Math.min(Math.max(page, 0), this.props.pages - 1);
    }

    changePage (page: any) {
        page = this.getSafePage(page);
        this.setState({ page });
        if (this.props.page !== page) {
            this.props.onPageChange(page);
        }

        this.updateCurrentRows(page);
    }

    applyPage (e: any) {
        if (e) { e.preventDefault(); }
        if (this.state) {
            const page = this.state.page;
            this.changePage(page === '' ? this.props.page : page);
        }
    }

    render () {
        const {
            // Computed
            pages,
            // Props
            page,
         //   showPageSizeOptions,
         //   pageSizeOptions,
         //   pageSize,
         // showPageJump,
            canPrevious,
            canNext,
         //   onPageSizeChange,
            className,
            PreviousComponent = defaultButton,
            NextComponent = defaultButton,
        } = this.props;
        return (
            <div
                className={classnames(className, '-pagination')}
                style={this.props.style}
            >
                <div className="pagination-button">
                    <PreviousComponent
                        onClick={() => {
                            if (!canPrevious) return;
                            this.changePage(0);
                        }}
                        disabled={!canPrevious}
                    >
                        <FontAwesome name="angle-double-left pagination-icons" />
                    </PreviousComponent>
                </div>
                <div className="pagination-button">
                    <PreviousComponent
                        onClick={() => {
                            if (!canPrevious) return;
                            this.changePage(page - 1);
                        }}
                        disabled={!canPrevious}
                    >
                        <FontAwesome name="angle-left pagination-icons" />
                    </PreviousComponent>
                </div>

                <div className="-pageInfo">
                {this.props.pageText}{' '}
                    <div className="-pageJump">
                      <input
                          type="text"
                          value={(this.state.page && !isNaN(this.state.page)) ? (this.state.page + 1) : 1}
                          onChange={e => {
                              if (e && e.target) {
                                  const val: any = e.target.value;
                                  // tslint:disable-next-line:no-shadowed-variable
                                  const page: any = val - 1;
                                  if (val === '') {
                                      return this.setState({page: val});
                                  }
                                  this.setState({page: this.getSafePage(page)});
                              }
                          }}
                          onKeyPress={e => {
                              if (e && (e.which === 13 || e.keyCode === 13)) {
                                  this.applyPage(e);
                              }
                          }}
                          onBlur={this.applyPage}
                      />
                    </div>
                    {this.props.ofText}{' '}
                    <span className="-totalPages">{pages || 1}</span>
                </div>

                <div className="pagination-button">
                    <NextComponent
                        onClick={() => {
                            if (!canNext) return;
                            this.changePage(page + 1);
                        }}
                        disabled={!canNext}
                    >
                        <FontAwesome name="angle-right pagination-icons"/>
                    </NextComponent>
                </div>
                <div className="pagination-button">
                    <NextComponent
                        onClick={() => {
                            if (!canNext) return;
                            this.changePage(pages);
                        }}
                        disabled={!canNext}
                    >
                        <FontAwesome name="angle-double-right pagination-icons"/>
                    </NextComponent>
                </div>
                <div className="pagination-right">
                    {(typeof this.rowCount !== 'undefined') ? (this.rowCount > 0)
                        ? <span className="-rowInfo">{'Displaying Records '}
                            <span className="-rowMin">{this.rowMin}</span>
                            {' - '}
                            <span className="-rowMax">{this.rowMax}</span>
                            {' of '}
                            <span className="-rowCount">{this.rowCount}</span>
                        </span>
                        : 'No Records to display' : ''}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/sys/pagination.tsx